"use client";

import React from "react";
import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";
import { decamelizeKeys } from "humps";

export default function Provider({ children }) {
  React.useEffect(() => {
    if (process.env.NODE_ENV === "production") {
      posthog.init(
        process.env.NEXT_PUBLIC_POSTHOG_KEY,
        decamelizeKeys({
          apiHost: "/ingest",
          uiHost: "https://us.posthog.com",
          capturePageview: false,
          capturePageleave: false,
          captureExceptions: false,
          persistence: "memory",
          debug: false,
        }),
      );
    }
  }, []);

  return process.env.NODE_ENV === "production" ? (
    <PHProvider client={posthog}>{children}</PHProvider>
  ) : (
    children
  );
}
